export const thColor = "#fff";
export const tdColor = "#fff";
export const tbBorderColor = "#dee2e6";
